import { render, staticRenderFns } from "./NavItemsList.vue?vue&type=template&id=4edc45d9&"
import script from "./NavItemsList.vue?vue&type=script&lang=js&"
export * from "./NavItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports